// extracted by mini-css-extract-plugin
export default {"signalIcon":"iK4FWLgcnrjgOeaS5tV4__signalIcon___","label":"K3ZiUXgRYtSn8qZ6_l0E__label___"};